module.exports = __webpack_public_path__ + "img/cooperate_5.bfb1df1c.png";